import React from 'react'
import ViewOption from 'enums/InsightViewOption'
import {
  SideBySideWidgetsType,
  SideBySideSimplifiedData,
  SideBySideSelectionType
} from '../../types'

import BaseInsightChart from './BaseInsightChart'
import StarRatingChart from './StarRatingChart'
import SurveyScoreChart from './SurveyScoreChart'
import InsightChartGuard from './InsightChartGuard'

const InsightChart = ({
  data,
  widgetSetting,
  onCellClick
}: {
  data: SideBySideSimplifiedData
  widgetSetting: SideBySideWidgetsType
  onCellClick: (target: SideBySideSelectionType) => void
}) => {
  const { viewOption, countType, topN } = widgetSetting

  switch (viewOption) {
    case ViewOption.STAR_RATINGS:
      return (
        <InsightChartGuard isVoc data={data}>
          <StarRatingChart data={data} onCellClick={onCellClick} />
        </InsightChartGuard>
      )
    case ViewOption.SURVEY_SCORES:
      return (
        <InsightChartGuard isVoc data={data}>
          <SurveyScoreChart data={data} onCellClick={onCellClick} />
        </InsightChartGuard>
      )
    case ViewOption.EMOJIS_EMOJI:
    case ViewOption.EMOJIS_EMOTION:
    case ViewOption.EMOJIS_GROUP:
      return (
        <InsightChartGuard data={data}>
          <BaseInsightChart
            data={data}
            countType={countType}
            isEmoji
            totalBars={topN!}
            onCellClick={onCellClick}
          />
        </InsightChartGuard>
      )
    case ViewOption.ATTRIBUTES:
    case ViewOption.EMOTIONS:
    case ViewOption.BEHAVIORS:
      return (
        <InsightChartGuard data={data}>
          <BaseInsightChart
            data={data}
            countType={countType}
            isSentiment
            totalBars={topN!}
            onCellClick={onCellClick}
          />
        </InsightChartGuard>
      )
    default:
      return (
        <InsightChartGuard data={data}>
          <BaseInsightChart
            data={data}
            countType={countType}
            totalBars={topN!}
            onCellClick={onCellClick}
          />
        </InsightChartGuard>
      )
  }
}

export default InsightChart
